import { render, staticRenderFns } from "./newPlusIcon.vue?vue&type=template&id=534953b0"
import script from "./newPlusIcon.vue?vue&type=script&lang=js"
export * from "./newPlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports